import React, { useEffect } from 'react';

interface Props {
  title?: string;
  subtitle?: string;
  message: string;
}

// Pantalla única para enlaces públicos (?learning= y ?psicosocial=) que no
// existen, vencieron o están cerrados. Marca la página como noindex: Vercel
// responde 200 a cualquier URL, así que sin esto sería un "soft 404".
export default function EnlaceNoDisponible({ title = 'Enlace no disponible', subtitle, message }: Props) {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  return (
    <div style={wrap}>
      <div style={card}>
        <p style={brand}>StorSafe</p>
        <h1 style={titleStyle}>{title}</h1>
        {subtitle && <p style={muted}>{subtitle}</p>}
        <p style={body}>{message}</p>
        <a href="/" style={btn}>Ir a la página principal</a>
      </div>
    </div>
  );
}

const wrap: React.CSSProperties = { minHeight: '100vh', background: '#0f172a', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '64px 16px', boxSizing: 'border-box' };
const card: React.CSSProperties = { background: '#1e293b', border: '1px solid #334155', borderRadius: 16, padding: 28, width: '100%', maxWidth: 480, textAlign: 'center' };
const brand: React.CSSProperties = { color: '#2FBF71', fontWeight: 800, letterSpacing: '0.04em', margin: '0 0 16px' };
const titleStyle: React.CSSProperties = { color: '#f1f5f9', fontSize: '1.3rem', fontWeight: 700, margin: '0 0 8px' };
const muted: React.CSSProperties = { color: '#94a3b8', fontSize: '0.9rem', margin: 0 };
const body: React.CSSProperties = { color: '#e2e8f0', lineHeight: 1.6, margin: '16px 0 24px' };
const btn: React.CSSProperties = { display: 'inline-block', background: '#2FBF71', color: '#0f172a', fontWeight: 700, padding: '10px 20px', borderRadius: 8, textDecoration: 'none' };
